import { render, staticRenderFns } from "./MyInvitation.vue?vue&type=template&id=3a5e5350&scoped=true&"
import script from "./MyInvitation.vue?vue&type=script&lang=js&"
export * from "./MyInvitation.vue?vue&type=script&lang=js&"
import style0 from "./MyInvitation.vue?vue&type=style&index=0&id=3a5e5350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e5350",
  null
  
)

export default component.exports